
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import regular from "@/common/regular";
import uploadImage from "@/components/upload-image/upload-image.vue";
import { upDeviceArchive } from "@/api/api-basic";
import showImg from "@/components/show-img/show-img.vue";
import i18n from "@/config/i18n";

@Component({
  components: {
    "pi-upload-image": uploadImage,
    "pi-show-img": showImg
  }
})
export default class PiUpdataReportFile extends Vue {
  private modalShow = false;
  private modalTitle = i18n.t("reportFile.updataTitle");
  private loading = false;
  private formInline: objAny = {
    attachmentRecordPkId: "",
    deviceArchivePkId: "",
    attachmentRecordName: ""
  };
  private ruleInline: objAny = {
    attachmentRecordPkId: [
      {
        required: true,
        message:
          i18n.t("regular.pleaseSelect") +
          "" +
          i18n.t("reportFile.attachmentRecordPkId"), //"请上传型式实验报告",
        trigger: "change"
      }
    ]
  };

  private isAdd = true;
  private itemData: objAny = {};
  private formObj: objAny = {};

  open(itemData: objAny) {
    this.modalShow = true;
    this.formInline.deviceArchivePkId = itemData.deviceArchivePkId;
    this.formInline.attachmentRecordPkId = "";
    this.formInline.attachmentRecordFilePath = "";
    this.formInline.attachmentRecordName = "";
  }
  closeModal() {
    this.modalShow = false;
  }

  public uploadImg(data: objAny): void {
    this.formInline.attachmentRecordFilePath = data.filePath;
    this.formInline.attachmentRecordName = data.fileName;
    this.formInline.attachmentRecordPkId = data.attachmentRecordPkId; //data.thumbnailFilePath;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.subData();
      }
    });
  }

  async subData(): Promise<void> {
    const ret = await upDeviceArchive({
      attachmentRecordPkId: this.formInline.attachmentRecordPkId,
      deviceArchivePkId: this.formInline.deviceArchivePkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess") + "");
      this.$emit("success");
      this.closeModal();
    }
    this.loading = false;
  }
  mounted() {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
  }
}
